import api from './api';
import { LeadsResponse, LeadFilters } from '../interfaces/Lead';

export const leadService = {
  getLeads: async (page: number = 1, limit: number = 50, filters?: LeadFilters): Promise<LeadsResponse> => {
    const response = await api.get<LeadsResponse>('/leads', {
      params: { page, limit, ...filters }
    });
    return response.data;
  },

  deleteLead: async (id: number): Promise<void> => {
    await api.delete(`/leads/${id}`);
  },

  updateContacted: async (id: number, contacted: boolean, username: string): Promise<void> => {
    await api.patch(`/leads/${id}/contacted`, { contacted, username });
  }
};
